export const tmaisBadgesColumns = [
  { label: 'Status', value: 'status', className: 'w-[120px]' },
  { label: 'Ícone', value: 'icon', className: 'w-[120px]' },
  { label: 'Nome do destaque', value: 'display_name', className: 'w-[240px]' },
  { label: 'Cor do background', value: 'background_color_cell', className: 'w-[200px]' },
  { label: 'Cor da fonte', value: 'text_color_cell', className: 'w-[200px]' },
  { label: 'Utilização', value: 'usage', className: 'w-[140px]' },
  { label: 'Ações', value: 'actions', className: 'w-[72px]' },
]
